import type { AmbleContent } from "..";

/**
 * US-specific ambles for SimpleBusiness US
 */
export const simplybusinessUsAmbles: Record<string, AmbleContent> = {
  // Add US-specific ambles here
};
